import createReactContext from 'create-react-context';
export var FormContext = createReactContext({
  labelAlign: 'right',
  vertical: false
});


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_antd@3.15.2@antd/es/form/context.js
// module id = 329
// module chunks = 0